import React from 'react';
import {Redirect as RedirectRouter} from "react-router-dom";

class Redirect extends React.Component {

    render() {
        if (this.props.url) {
            return (<RedirectRouter to={this.props.url}/>);
        } else {
            return (null);
        }
    }

}

export default Redirect